import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "./firebaseConfig";
import "./index.css";

const ALLOWED_EMAILS = [
  "alexandracarreira@vsolutions.pt",
  "raioxmail@gmail.com"
];

function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setpassword] = useState("");
  const [error, seterror] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    seterror("");

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      const emailNormalizado = user.email.trim().toLowerCase();
      const emailsPermitidos = ALLOWED_EMAILS.map(e => e.toLowerCase());

      if (emailsPermitidos.includes(emailNormalizado)) {
        onLogin(user); 
      } else {
        seterror("Acesso de entrada negado");
      }
    } catch (err) {
      seterror("Email ou palavra-passe incorretos");
      console.errorr(err);
    }
  };

return (
  <div style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f0f4f8",
    fontFamily: "Arial, sans-serif"
  }}>
    <form 
      onSubmit={handleLogin} 
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "40px",
        borderRadius: "12px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        width: "320px",
      }}
    >
      <img 
        src="/Logo.png" 
        alt="Logo"
        style={{ width: "80px", marginBottom: "24px" }} 
      />

      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={{
          width: "100%",
          padding: "12px 16px",
          marginBottom: "16px",
          borderRadius: "8px",
          border: "1px solid #ccc",
          fontSize: "14px",
        }}
      />

      <input
        type="password"
        placeholder="Palavra-passe"
        value={password}
        onChange={(e) => setpassword(e.target.value)}
        style={{
          width: "100%",
          padding: "12px 16px",
          marginBottom: "24px",
          borderRadius: "8px",
          border: "1px solid #ccc",
          fontSize: "14px",
        }}
      />

      <button 
        type="submit"
        style={{
          width: "100%",
          padding: "12px",
          borderRadius: "8px",
          border: "none",
          backgroundColor: "#02826d",
          color: "#fff",
          fontWeight: "bold",
          cursor: "pointer",
          transition: "background-color 0.3s"
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#026c5b"}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#02826d"}
      >
        Entrar
      </button>

      {error && <p style={{ color: "red", marginTop: "16px", fontSize: "13px", textAlign: "center" }}>{error}</p>}
    </form>
  </div>
  
  );
}

export default Login;
